
import * as React from "react";
import { Component } from "react";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import RemoveIcon from '@material-ui/icons/Remove';


export default class PickupDestinationView extends Component {


    constructor(props) {
        super(props);

        this.state = {
            order: props.order
          };

    }

    render() {
        return (

            <div style={{textAlign:'right', marginRight:15, marginTop: 10}}>
             
            <div>
            <div style={{display:'inline-flex', marginRight: 10, fontWeight:'bold'}}>
          {this.props.pickup}
          </div>
            <RadioButtonUncheckedIcon style={{
                     color:'#101010', 
                     fontSize: 14, width: 15, height: 15
              }}/>



        

                </div>
           
       <div style={{marginTop: -10}}>
   
       <RemoveIcon style={{
                     color:'#101010', transform: `rotate(90deg)`, marginRight:-5, marginTop: -8, marginBottom: -4,
                     fontSize: 25,// height: 15, 
              }}/>
   </div>
   <div style={{marginTop: -5}}>

        <div style={{display:'inline-flex', marginRight: 10, fontWeight:'bold'}}>
        {this.props.destination}
          </div>
   <Brightness1Icon style={{
                     color:'#101010',
                     fontSize: 14, width: 15, height: 15, 
              }}/>

   </div>
           
          </div>

           
        )
    }

}